import { render, staticRenderFns } from "./DocumentFilesPopup.vue?vue&type=template&id=90dae112"
import script from "./DocumentFilesPopup.vue?vue&type=script&lang=ts"
export * from "./DocumentFilesPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports